import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import ClButtonBase from '../ClButtonBase/ClButtonBase';
import { clx, capitalize } from '../../lib';
import { CreateElement, VNodeData } from 'vue';

type Classes = {
  root: any;
  textColorPrimary: any;
  textColorSecondary: any;
  textColorInherit: any;
  disabled: any;
  selected: any;
  fullWidth: any;
  [key: string]: any;
};

type TextColor = 'secondary' | 'primary' | 'inherit';

@Component({
  components: { ClButtonBase }
})
export default class ClTab extends Vue {
  @Prop({
    type: Object as () => Classes,
    default: () => ({
      root: ''
    })
  })
  readonly classes!: Classes;

  @Prop({
    type: Boolean,
    default: false
  })
  readonly disabled!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  readonly fullWidth!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  readonly selected!: boolean;

  @Prop({
    type: String as () => TextColor,
    default: ''
  })
  readonly textColor!: TextColor;

  @Prop({
    type: [String, Number],
    required: true
  })
  readonly value!: string | number;

  @Prop({
    type: Boolean,
    default: false
  })
  readonly wrapped!: boolean;

  handleClick(event: Event): void {
    if (typeof this.$listeners.click === 'function') {
      this.$listeners.click(event, this.value);
    }
  }

  render(h: CreateElement) {
    const {
      $slots,
      classes,
      disabled,
      selected,
      fullWidth,
      wrapped,
      textColor
    } = this;
    return (
      <ClButtonBase
        role="tab"
        class={clx(
          {
            'cl-tab': true,
            'cl-tab--wrapped': wrapped,
            'cl-tab--full-width': fullWidth
          },
          classes.root,
          classes[`textColor${capitalize(textColor)}`],
          disabled && classes.disabled,
          selected && classes.selected,
          fullWidth && classes.fullWidth
        )}
        {...{
          on: {
            ...this.$listeners,
            click: this.handleClick
          },
          attrs: {
            'aria-selected': String(selected)
          }
        }}
      >
        {$slots.default}
      </ClButtonBase>
    );
  }
}
